import {
  Box,
  FormControlLabel,
  Grid2,
  Radio,
  RadioGroup,
  Switch,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateProfile } from "Slices/thunks";
import { ReactComponent as MailIcon } from "Assets/Icons/Settings/MailIcon.svg";
import { ReactComponent as CallIcon } from "Assets/Icons/Settings/CallIcon.svg";
import { ReactComponent as WhatsappIcon } from "Assets/Icons/Settings/WhatsappIcon.svg";
import { ReactComponent as NotificationIcon } from "Assets/Icons/Home/NotificationIcon.svg";
import PrimaryIcon from "Components/Common/PrimaryIcon";
import { profileInfo } from "Constants/data";

const styles = (theme) => ({
  display: "flex",
  flexDirection: "column",
  gap: "20px",
  border: `1px solid ${theme.palette.border.blue}`,
  borderRadius: "8px",
  padding: "16px",
  "& .blueIcon": {
    background: theme.palette.primary.main,
    padding: "4px",
    borderRadius: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  "& .radioGroup": {
    "& label": {
      flexDirection: "row-reverse",
      marginLeft: "0px",
      marginRight: "0px",
      justifyContent: "space-between",
      "& .MuiRadio-root": {
        padding: "4px",
      },
    },
  },
});

const Notifications = ({ profileInfo }) => {
  const dispatch = useDispatch();
  const [notifications, setNotifications] = useState(profileInfo);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setNotifications((pre) => ({ ...pre, [name]: value }));
    dispatch(updateProfile({[name]: value}))
  }

  const handleSwitch = (e) => {
    const { name, checked } = e.target;
    setNotifications((pre) => ({ ...pre, [name]: checked }));
   
    dispatch(updateProfile({[name]: checked}))
  }

  const { Translation } = useSelector((state) => ({
    Translation: state.Translation.translation?.Settings || {},
  }));

  return (
    <>
      <Grid2 sx={styles}>
        <Typography fontWeight={500} variant="title">
          {Translation?.Notifications}
        </Typography>
        <Box display={"flex"} flexDirection={"column"} gap={"5px"}>
          <Typography
            display={"flex"}
            fontWeight={500}
            alignItems={"center"}
            gap="6px"
            variant="subtitle"
            color="secondary"
          >
            <span className="blueIcon">
              <PrimaryIcon
                icon={MailIcon}
                color="white"
                width="16px"
                height="16px"
              />
            </span>
            {Translation?.AllowEmailNotifications}
          </Typography>
          <Typography variant="body2" color="secondary.light">
            {Translation?.EnableEmailNotification}
          </Typography>
        </Box>
        <Box>
          <RadioGroup
            value={notifications?.EmailNotificationID}
            onChange={handleChange}
            name="EmailNotificationID"
            className="radioGroup"
          >
            <FormControlLabel
              value="1"
              control={<Radio size="small" />}
              label={
                <Typography color="secondary.light">
                  {" "}
                  {Translation?.AllNotifications}{" "}
                </Typography>
              }
            />
            <FormControlLabel
              value="2"
              control={<Radio size="small" />}
              label={
                <Typography color="secondary.light">
                  {" "}
                  {Translation?.ImportantNotifications}
                </Typography>
              }
            />
            <FormControlLabel
              value="3"
              control={<Radio size="small" />}
              label={
                <Typography color="secondary.light">
                  {" "}
                  {Translation?.NotificationAboutAccount}
                </Typography>
              }
            />
          </RadioGroup>
        </Box>
        <Box
          display={"flex"}
          justifyContent={"space-between"}
          alignItems={"center"}
        >
          <Box display={"flex"} flexDirection={"column"} gap={"5px"}>
            <Typography
              display={"flex"}
              fontWeight={500}
              alignItems={"center"}
              gap="6px"
              variant="subtitle"
              color="secondary"
            >
              <PrimaryIcon
                icon={WhatsappIcon}
                fill={false}
                width="24px"
                height="24px"
              />
              {Translation?.AllowWhatsAppNotification}
            </Typography>
            <Typography
              display={"flex"}
              alignItems={"center"}
              gap="5px"
              variant="body2"
              color="secondary.light"
            >
              {Translation?.ImportantUpdates}
              <PrimaryIcon
                icon={NotificationIcon}
                height="18px"
                width="18px"
                fill={false}
              />
            </Typography>
          </Box>
          <Switch size="small" name="WhatsappNotification" onChange={handleSwitch} checked={notifications.WhatsappNotification} />
        </Box>
        <Box
          display={"flex"}
          justifyContent={"space-between"}
          alignItems={"center"}
        >
          <Box display={"flex"} flexDirection={"column"} gap={"5px"}>
            <Typography
              display={"flex"}
              fontWeight={500}
              alignItems={"center"}
              gap="6px"
              variant="subtitle"
              color="secondary"
            >
              <span className="blueIcon">
                <PrimaryIcon
                  icon={CallIcon}
                  color="white"
                  width="16px"
                  height="16px"
                />
              </span>
              {Translation?.AllowIVRCallReminders}
            </Typography>
            <Typography variant="body2" color="secondary.light">
              {Translation?.CallReminder}
            </Typography>
          </Box>
          <Switch size="small" name="IVRCall" onChange={handleSwitch} checked={notifications.IVRCall} />
        </Box>
        <Typography variant="subtitle" fontWeight={500}>
          {Translation?.Newsletter}
        </Typography>
        <Box>
          <Box
            display={"flex"}
            alignItems={"center"}
            justifyContent={"space-between"}
          >
            <Typography color="secondary.light">
              {Translation?.InterviewExperience}
            </Typography>
            <Switch size="small" name="NewsLetter" onChange={handleSwitch} checked={notifications.NewsLetter}  />
          </Box>
          {/* <Box
            display={"flex"}
            alignItems={"center"}
            justifyContent={"space-between"}
          >
            <Typography color="secondary.light">
              Subscribe to Interview-Experiences newsletter
            </Typography>
            <Switch size="small" />
          </Box>{" "}
          <Box
            display={"flex"}
            alignItems={"center"}
            justifyContent={"space-between"}
          >
            <Typography color="secondary.light">
              Subscribe to Interview-Experiences newsletter
            </Typography>
            <Switch size="small" />
          </Box> */}
        </Box>
      </Grid2>
    </>
  );
};

export default Notifications;
